"use strict";

const WorkList = {
  el: null,
  list: null,
  loadMore: null,
  currentFilter: null,
  noResult: null,
  currentItems: [],
  nbrDisplay: 20,
  init: function () {
    WorkList.el = document.querySelector(".f-workList");

    if (WorkList.el) {
      WorkList.list = WorkList.el.querySelector(".f-workList__list");
      WorkList.loadMore = WorkList.el.querySelector("#loadMore");
      WorkList.currentItems =
        WorkList.list.querySelectorAll(".f-workList__item");
      WorkList.noResult = WorkList.el.querySelector(
        ".f-workList__noResult"
      );

      if (WorkList.loadMore && WorkList.list) {
        WorkList.loadMore.addEventListener("click", WorkList.loadMoreItems);

        if (WorkList.currentItems.length <= WorkList.nbrDisplay) {
          WorkList.loadMore.parentNode.classList.add("hide");
        }

        if (WorkList.currentItems.length === 0) {
          WorkList.noResult.classList.add("show--");
        }
      }

      WorkList.filters = WorkList.el.querySelectorAll(".c-filters__item");

      if (WorkList.filters.length) {
        WorkList.filters.forEach((filter) => {
          if (filter.dataset.value) {
            filter.addEventListener("click", WorkList.filterItems);
          }
        });
      }
    }
  },
  filterItems: function (e) {
    // Reset
    WorkList.nbrDisplay = 20;
    WorkList.list
      .querySelectorAll(".f-workList__item")
      .forEach((li) => li.classList.add("hidden"));
    WorkList.loadMore.parentNode.classList.add("hide");
    WorkList.noResult.classList.remove('show--')

    // Unselect filter
    if (WorkList.currentFilter === e.target.dataset.value) {
      WorkList.currentFilter = null;
      WorkList.currentItems =
        WorkList.list.querySelectorAll(".f-workList__item");

      // Select filter
    } else {
      WorkList.currentFilter = e.target.dataset.value;

      let filteredItems = [];
      WorkList.list.querySelectorAll(".f-workList__item").forEach((el) => {
        let categories = el.dataset.categories
          .split(",")
          .map((data) => data.replace(" ", ""));
        if (categories.includes(WorkList.currentFilter)) {
          filteredItems.push(el);
        }
      });

      WorkList.currentItems = filteredItems;
    }

    if (WorkList.currentItems.length > WorkList.nbrDisplay) {
      WorkList.loadMore.parentNode.classList.remove("hide");
    }

     if(WorkList.currentItems.length === 0){
        WorkList.noResult.classList.add('show--')
    }

    for (let i = 0; i < WorkList.nbrDisplay; i++) {
      if (WorkList.currentItems[i]) {
        WorkList.currentItems[i].classList.remove("hidden");
      }
    }
  },
  loadMoreItems: function () {
    let nbrChildren = WorkList.currentItems.length;

    WorkList.list
      .querySelectorAll(".f-workList__item")
      .forEach((li) => li.classList.add("hidden"));

    if (WorkList.nbrDisplay + 20 <= nbrChildren) {
      WorkList.nbrDisplay += 20;
      for (let i = 0; i < WorkList.nbrDisplay; i++) {
        WorkList.currentItems[i].classList.remove("hidden");
      }
    } else {
      WorkList.nbrDisplay = nbrChildren;
      WorkList.currentItems.forEach((li) => li.classList.remove("hidden"));
      WorkList.loadMore.parentNode.classList.add("hide");
    }
  },
};

export default WorkList;
